import { get } from 'lodash'
import Keycloak from 'keycloak-js'
import { setCookie } from 'tiny-cookie'
import { COOKIE_OPTIONS } from '../../cookies/cookies'

class KeycloakAuthenticator {
  constructor() {
    const config = get(window, 'config', {})
    KeycloakAuthenticator._instance = new Keycloak({
      url: get(config, 'sso.keycloak.host'),
      realm: get(config, 'sso.keycloak.realm'),
      clientId: get(config, 'sso.keycloak.client'),
      pkceMethod: false,
    })
  }

  login() {
    return KeycloakAuthenticator._instance.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
    })
  }

  logout() {
    setCookie('isLoggedIn', false, {
      expires: '1D',
      ...COOKIE_OPTIONS,
    })
    return KeycloakAuthenticator._instance.logout()
  }

  getLogoutUrl() {
    let logoutUrl = ''
    try {
      logoutUrl = KeycloakAuthenticator._instance.createLogoutUrl()
    } catch (error) {
      // nincs élő sessionje a usernek
    }
    return logoutUrl
  }

  async refreshToken() {
    let refreshToken
    try {
      refreshToken = await KeycloakAuthenticator._instance.updateToken(30)
    } catch (error) {
      console.error('Failed to refresh token:', error)
    }
    return refreshToken
  }

  getToken() {
    return get(KeycloakAuthenticator._instance, 'token')
  }
}

export default KeycloakAuthenticator
